export const bonuses = [
  {
    number: 1,
    title: "The Aesthetic Laser Technology Comparison Atlas",
    tagline: "Compare major technology categories in one organized educational reference.",
    intro: [
      "Understanding the differences between laser technology categories can make studying their characteristics and applications more structured.",
      "This visual reference organizes key educational concepts into comparison charts.",
    ],
    items: [
      "Laser technology comparison tables",
      "Wavelength reference charts",
      "Chromophore and absorption concept summaries",
      "Ablative versus non-ablative technology comparisons",
      "Fractional technology educational diagrams",
      "Technology terminology reference sheets",
      "Educational application comparison worksheets",
    ],
    note: "",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/wfFoSj8JXrwhX7LDceeh78/BONUS_1_LASER-EN.png",
  },
  {
    number: 2,
    title: "The Skin Assessment & Consultation Toolkit",
    tagline: "Organize relevant patient information and skin assessment considerations.",
    intro: [
      "This toolkit provides educational forms and worksheets for organizing consultation information and documenting relevant observations.",
    ],
    items: [
      "Consultation preparation checklist",
      "Patient history worksheet",
      "Skin characteristic observation form",
      "Fitzpatrick phototype documentation reference",
      "Patient expectation discussion worksheet",
      "Contraindication review prompts",
      "Consultation documentation template",
    ],
    note: "All materials should be adapted to the professional’s scope and applicable requirements.",
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/att8vXnSP8MraesQrLhBBp/BONUS_2_LASER-EN.png",
  },
  {
    number: 3,
    title: "The Aesthetic Laser Safety Checklist Pack",
    tagline: "Keep essential educational safety references organized.",
    intro: [
      "This resource brings together checklists for reviewing laser safety concepts and organizing relevant professional documentation.",
    ],
    items: [
      "Laser safety review checklist",
      "Protective eyewear consideration worksheet",
      "Treatment room safety review template",
      "Equipment documentation checklist",
      "Pre-procedure safety review worksheet",
      "Adverse-event documentation form",
      "Safety training review tracker",
    ],
    note: "These checklists complement, rather than replace, approved safety procedures and device-specific instructions.",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/cS8NtKhnqD4xMADFudo7mx/BONUS_3_LASER-EN.png",
  },
  {
    number: 4,
    title: "The Aesthetic Laser Clinical Casebook",
    tagline: "Study hypothetical cases through a structured educational framework.",
    intro: [
      "Case-based learning provides an opportunity to organize observations, compare educational references, and discuss relevant clinical considerations.",
      "This casebook contains hypothetical scenarios designed for professional education.",
    ],
    items: [
      "Hypothetical aesthetic laser case summaries",
      "Skin characteristic review exercises",
      "Technology selection discussion scenarios",
      "Treatment planning consideration worksheets",
      "Potential risk identification exercises",
      "Case analysis questions",
      "Structured learning review templates",
    ],
    note: "The cases are educational examples, not validated clinical protocols or individualized treatment recommendations.",
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/8mpjP9iV1yWShGAa7M5V7y/BONUS_4_LASER-EN.png",
  },
  {
    number: 5,
    title: "The Aesthetic Laser Documentation & Follow-Up Toolkit",
    tagline: "Organize treatment records, photographic references, and follow-up information.",
    intro: [
      "This practical resource complements the sixth volume with additional templates for organizing documentation.",
    ],
    items: [
      "Consultation record templates",
      "Treatment documentation worksheets",
      "Photographic record checklists",
      "Follow-up observation forms",
      "Patient communication logs",
      "Adverse-event documentation worksheets",
      "Professional record organization checklist",
    ],
    note: "Adapt all materials to applicable privacy requirements and local professional standards.",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/nTXPem3rH4S46y3zLQaFnB/BONUS_5_LASER-EN.png",
  },
];
